import { atom, useAtom } from 'jotai';
// For each set that is being checked in, we store the trays locally in memory
import { DecantedTraysDetails } from 'api/models/Trays';

export type CapturedImage = {
  captureId: string;
  dataUri: string;
  gsImagePath?: string;
  uploadPromise?: Promise<void>;
};

export type CheckInTray = {
  trayInstanceId?: string; // for existing delivery set trays, e.g. sadl sets
  name: string;
  trayReference?: number | null;
  assetNumber?: string;
  decantedTrays?: DecantedTraysDetails[];
  //imageDataUri?: string;
  trayImage?: CapturedImage;
  allDevicesCleanOfDebris?: boolean;
  allDevicesFunctional?: boolean;
  allDevicesInTray?: boolean;
  missingPartsComment?: string;
  comments?: string;
  completed?: boolean;
  //decantedImageDataUris?: string[];
  //decantGSImagePath?: string[];
  decantedImages?: CapturedImage[];
};

export type CheckInTrays = {
  // checkInTrayId is used to identify the tray locally and will not be sent to the BE
  [checkInTrayId: string]: CheckInTray;
};

export type CheckInSet = {
  name?: string;
  trays: CheckInTrays;
  postCheckinTrayAdd?: boolean;
};

export type CheckInTraysBySet = {
  [setKitInstanceId: string]: CheckInSet;
};

export const checkInTraysBySetAtom = atom<CheckInTraysBySet>({});

export const useCheckInTraysBySet = () => useAtom(checkInTraysBySetAtom);
